import {
  AccessibleIcon,
  IconCheckCircleFill,
  IconWarningCircleFill
} from '@vtex/shoreline'

const themes: BadgeIsValidTheme = {
  valid: {
    icon: IconCheckCircleFill,
    color: 'var(--sl-color-green-10)',
    label: 'Valid'
  },
  invalid: {
    icon: IconWarningCircleFill,
    color: 'var(--sl-bg-critical-strong)',
    label: 'Invalid'
  }
}

const BadgeIsValid = ({ isValid }: BadgeIsValidProps) => {
  const element = isValid ? themes.valid : themes.invalid

  return (
    <AccessibleIcon label={element.label}>
      <element.icon color={element.color} />
    </AccessibleIcon>
  )
}

export default BadgeIsValid
